import { Component, OnInit, Renderer2 } from '@angular/core';
import { environment } from '../../../../src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-tnc',
  templateUrl: './tnc.component.html',
  styleUrls: ['./tnc.component.scss']
})
export class TncComponent implements OnInit {
  haloWebCloudURL:string = environment.haloWebCloudBasePath;
  haloCloudURL:string = environment.tncBasePath;
  assetsUrl: string = environment.assetsUrl;
  countryIsoCode: string = 'us';
  countryCodeShowDataTransfer = ['gb','nl','fr','de','es'];
  countryCodeShowDataTransferForEUCountries = [
    // EU Countries
    'at','be','bg','hr','cy','cz','dk','ee','fi','fr','de','gr','hu','ie','it','lv','lt','lu','mt','nl','pl','pt','ro','sk','si','es','se','gb'
  ];
  showDeveloperTnc = true;
  showDataTransferAgreement = false;
  previousSelectedTncTab = '';
  preferredLanguage = 'en_US';
  htmlData:any = '';
  documentMap : { [key: string]: any } = {
    tnc: {
      'gb': 'en',
      'hk': 'zhl',
      'jp': 'ja',
      'kr': 'ko',
      'be': 'nl',
      'se': 'sv',
      'ae': 'ar',
      'il': 'he',
      'ca': 'ca',
      'cy': 'cy',
      'da': 'da',
      'de': 'de',
      'es': 'es',
      'eu': 'eu',
      'fi': 'fi',
      'fr': 'fr',
      'hu': 'hu',
      'it': 'it',
      'nl': 'nl',
      'pl': 'pl',
      'pt': 'pt',
      'ru': 'ru',
      'tr': 'tr',
      'zh': 'zh',
    },
    privacy: {
      'gb': 'en',
      'hk': 'zhl',
      'jp': 'ja',
      'kr': 'ko',
      'be': 'nl',
      'se': 'sv',
      'ae': 'ar',
      'br': 'pt_BR',
      'il': 'he',
      'ca': 'ca',
      'cy': 'cy',
      'da': 'da',
      'de': 'de',
      'es': 'es',
      'eu': 'eu',
      'fi': 'fi',
      'fr': 'fr',
      'hu': 'hu',
      'it': 'it',
      'nl': 'nl',
      'pl': 'pl',
      'pt': 'pt',
      'ru': 'ru',
      'tr': 'tr',
      'zh': 'zh',
      // Latin Americans
      'ar': 'es_LA',
      'bo': 'es_LA',
      //'br': 'es_LA',
      'cl': 'es_LA',
      'co': 'es_LA',
      'cr': 'es_LA',
      'cu': 'es_LA',
      'do': 'es_LA',
      'ec': 'es_LA',
      'sv': 'es_LA',
      'gt': 'es_LA',
      'hn': 'es_LA',
      'mx': 'es_LA',
      'ni': 'es_LA',
      'pa': 'es_LA',
      'py': 'es_LA',
      'pe': 'es_LA',
      'pr': 'es_LA',
      'ht': 'es_LA',
      'uy': 'es_LA',
      've': 'es_LA',
    },
    cookiePolicy: {
      'gb': 'en',
      'hk': 'zhl',
      'jp': 'ja',
      'kr': 'ko',
      'be': 'nl',
      'se': 'sv',
      'ae': 'ar',
      'il': 'he',
      'ca': 'ca',
      'cy': 'cy',
      'da': 'da',
      'de': 'de',
      'es': 'es',
      'eu': 'eu',
      'fi': 'fi',
      'fr': 'fr',
      'hu': 'hu',
      'it': 'it',
      'nl': 'nl',
      'pl': 'pl',
      'pt': 'pt',
      'ru': 'ru',
      'tr': 'tr',
      'zh': 'zh',
    },
    subscriptionAgreement: {},
    dataTransferAgreement: {
      'gb': 'en',
      'be': 'nl',
      'de': 'de',
      'es': 'es',
      'fr': 'fr',
      'nl': 'nl',
    },
    apiTermsOfUse: {},
  }; //en_AUS docs are same with en_US
  dataTransferLangCodeMap : { [key: string]: any } = {    
    'en': 'gb',
    'nl': 'nl',
    'de': 'de',
    'es': 'es',
    'fr': 'fr'
  }
  tnc = 'tnc';
  privacy = 'privacy';
  cookiePolicy = 'cookiePolicy';
  subscriptionAgreement = 'subscriptionAgreement';
  dataTransferAgreement = 'dataTransferAgreement';
  apiTermsOfUse = 'apiTermsOfUse';
  selectedTncTab = this.privacy;
  rootScopeData: RootScopeDeclare;

  constructor(private rootScopeService: RootScopeService, private _translate: TranslateService, private activatedRoute: ActivatedRoute,private sanitizer: DomSanitizer,private http :HttpClient) {
    this.showDeveloperTnc = this.activatedRoute.snapshot.queryParams['developerMode']=='true';
    this.preferredLanguage = this.activatedRoute.snapshot.queryParams['locale']??'en_US';
    this.countryIsoCode = this.activatedRoute.snapshot.queryParams['country'];
    this.selectedTncTab = this.activatedRoute.snapshot.queryParams['selectedTncTab'] ?? this.privacy;
    this.loadStyleSheet();
  }
  
  loadStyleSheet(){
    var headerLink = document.createElement('link');
    headerLink.rel = "stylesheet";
    headerLink.type = "text/css";
    headerLink.href = environment.currentHostPath + '/assets/css/header.min.css?v=1252';
    document.head.appendChild(headerLink);
    var commonLink = document.createElement('link');
    commonLink.rel = "stylesheet";
    commonLink.type = "text/css";
    commonLink.href = environment.currentHostPath + '/assets/css/commonStyle.min.css?v=1252';
    document.head.appendChild(commonLink);
    var commonLink = document.createElement('link');
    commonLink.rel = "stylesheet";
    commonLink.type = "text/css";
    commonLink.href = environment.currentHostPath + '/assets/css/foundation.min.css';
    document.head.appendChild(commonLink);
  }

  ngOnInit(): void {
    document.addEventListener('click', (clickEvent: any) => {
      if (clickEvent.srcElement.id === 'privacy-policy-id') {
        this.goToTncTab('privacy');
      }
      if (clickEvent.srcElement.id === 'terms-of-use-id') {
        this.goToTncTab('tnc');
      }
    })
    if(this.showDeveloperTnc) {
      let countryCode = this.countryIsoCode;
      if(!this.countryIsoCode) countryCode = this.dataTransferLangCodeMap[this.preferredLanguage];
      if(countryCode) this.showDataTransferAgreement = this.countryCodeShowDataTransferForEUCountries.find(e => e === countryCode.toLowerCase())!== undefined;
    } else if(this.countryIsoCode) {
      this.showDataTransferAgreement = this.countryCodeShowDataTransfer.find(e => e === this.countryIsoCode.toLowerCase())!== undefined;
    }
    this.rootScopeService.getRootScope().subscribe((rootScopeData: any) => this.rootScopeData = rootScopeData);
    this._selectLanguage(this.preferredLanguage);
    this.loadTncTabContent();
  }

  goToTncTab(tabSelected:string) {
    if(tabSelected !== this.selectedTncTab) {
      this.selectedTncTab = tabSelected;
      this.loadTncTabContent();
    }
	}
  
	async loadTncTabContent() {   
    if(this.countryIsoCode) {
      this.preferredLanguage = this.documentMap[this.selectedTncTab as any][this.countryIsoCode.toLowerCase()]??'en_US';
    } 
		let myurl = `${this.haloCloudURL}/tnc/${this.preferredLanguage}/${this.selectedTncTab}.html`;
    await this.http.get(myurl,{responseType:'text'}).toPromise().then(res => {
      this.htmlData = this.sanitizer.bypassSecurityTrustHtml(res);
    })
	}

  private _selectLanguage(langCode: string) {
    this.rootScopeData.translationsLoaded = false;
    this.rootScopeData.selectedLang = langCode;
    localStorage.setItem('selectedLang', langCode);
    this._translate.use(this.rootScopeData.selectedLang).subscribe(() => {
      this.rootScopeData.translationsLoaded = true;
    });
    if (this.rootScopeData.selectedLang === 'ar' || this.rootScopeData.selectedLang === 'he') {
      this.rootScopeService.changeToRtl();
    } else {
      this.rootScopeService.changeToLtr();
    }
  }
}
